import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UsersettingsComponent } from './usersettings.component';
import {UsersettingsRouting} from './usersettings.route';
import { OrdermainComponent } from './ordermain/ordermain.component';
import { OrderdetailsComponent } from './orderdetails/orderdetails.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentdetailComponent } from './appointmentdetail/appointmentdetail.component';
import { ManagepetComponent } from './managepet/managepet.component';
import { AddpetComponent } from './addpet/addpet.component';
import { ManageprofileComponent } from './manageprofile/manageprofile.component';
import { UpdateprofileComponent } from './updateprofile/updateprofile.component';

import { AddshippingComponent } from './addshipping/addshipping.component';
import { NgxLoadingModule } from 'ngx-loading';
import {Ng2UploaderModule} from 'ng2-uploader';
import { UseraddressComponent } from './useraddress/useraddress.component';
import { MapComponent } from './map/map.component';
import {AgmCoreModule, GoogleMapsAPIWrapper} from '@agm/core';
import { EditaddressComponent } from './editaddress/editaddress.component';
import { PetdetailComponent } from './petdetail/petdetail.component';
import { PasswordresetComponent } from './passwordreset/passwordreset.component';
import { VerifymobileComponent } from './verifymobile/verifymobile.component';
import { AdoptionhistoryComponent } from './adoptionhistory/adoptionhistory.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../common/shared.module';
import { MatSnackBarModule, MatDialogModule, MatCardModule, MatTabsModule, MatIconModule, MatDatepicker, MatInputModule, MatFormFieldModule, MatInput, MatRadioModule } from '@angular/material';
import {MatDatepickerModule} from '@angular/material/datepicker';
@NgModule({
    imports: [
      CommonModule,
      FlexLayoutModule,
      FormsModule,
      NgbModule,
      UsersettingsRouting,
      ReactiveFormsModule,
     Ng2UploaderModule,
     NgxLoadingModule,
     NgxPaginationModule,
     SharedModule,
     AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCVSpuWBEclSSgdccExuKLlKUORxWSqUFU'
    }),
    MatSnackBarModule,MatDialogModule,MatCardModule,MatTabsModule,MatIconModule,
    MatInputModule,MatDatepickerModule,MatFormFieldModule, MatRadioModule
    ],
    declarations: [
      UsersettingsComponent,
      OrdermainComponent,
      OrderdetailsComponent,
      AppointmentComponent,
      AppointmentdetailComponent,
      ManagepetComponent,
      AddpetComponent,
      ManageprofileComponent,
      UpdateprofileComponent,
      AddshippingComponent,
      UseraddressComponent,
      MapComponent,
      EditaddressComponent,
      PetdetailComponent,
      PasswordresetComponent,
      VerifymobileComponent,
      AdoptionhistoryComponent,
       ],

       entryComponents: [
        UpdateprofileComponent,
        MapComponent,
        VerifymobileComponent,
        PasswordresetComponent,
     ],
     providers: [ GoogleMapsAPIWrapper ],
    })
    export class UserSettingsModule { }
